import React from 'react';
import { Box, CircularProgress } from '@mui/material';
import Logo from '../assets/headerlogo.png'; // Adjust path if needed

const CustomLoadingScreen = () => (
  <Box
    sx={{
      width: '100vw',
      height: '100vh',
      bgcolor: '#181F2A',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'column',
      position: 'fixed',
      top: 0,
      left: 0,
      zIndex: 2000,
    }}
  >
    <Box sx={{ position: 'relative', width: 120, height: 120, mb: 3 }}>
      <CircularProgress size={120} thickness={3} sx={{ color: '#F9AA33', position: 'absolute', top: 0, left: 0 }} />
      <Box
        sx={{
          width: 70,
          height: 70,
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <img src={Logo} alt="Logo" style={{ width: '100%', height: '100%' }} />
      </Box>
    </Box>
  </Box>
);

export default CustomLoadingScreen; 